import { render, staticRenderFns } from "./CompQrCode.vue?vue&type=template&id=1570ee46&"
import script from "./CompQrCode.vue?vue&type=script&lang=js&"
export * from "./CompQrCode.vue?vue&type=script&lang=js&"
import style0 from "./CompQrCode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports